<script lang="ts" setup>
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faFilters } from "@fortawesome/pro-solid-svg-icons";
import type { RouteLocationRaw } from "vue-router";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

defineProps<{
    returns?: string | RouteLocationRaw;
    icon?: IconDefinition;
    label?: string;
    title?: string;
    description?: string;
}>();
</script>

<template>
    <div class="relative flex-1 flex flex-col h-full lg:overflow-hidden">
        <div
            class="px-8 py-4 md:grid-cols-3 lg:p-8 flex border-b-8 border-hd-neutral-50"
        >
            <UButton
                v-if="returns"
                :to="returns"
                class="btn btn-sm normal-case self-center mr-4 flex items-center justify-center w-9 h-9"
                square
                size="sm"
                color="gray"
            >
                <FontAwesomeIcon :icon="faChevronLeft" class="text-base" />
            </UButton>
            <div class="flex flex-1 flex-col gap-1">
                <NuxtLink
                    v-if="label && returns"
                    :to="returns"
                    class="text-sm opacity-50 font-medium -mb-2 hover:underline font-display"
                    >{{ label }}
                </NuxtLink>
                <span
                    v-else-if="label"
                    class="text-sm opacity-50 font-medium -mb-2 font-display"
                    >{{ label }}</span
                >
                <h2
                    v-if="title || $slots.title"
                    class="text-xl font-medium whitespace-nowrap font-display"
                >
                    <FontAwesomeIcon
                        v-if="icon"
                        :icon="icon"
                        class="mr-2"
                        fixed-width
                    />
                    <slot name="title">{{ title }}</slot>
                </h2>
                <p v-if="description" class="opacity-50">{{ description }}</p>
            </div>
            <div class="flex-1 flex items-center justify-end text-end gap-4">
                <UPopover
                    v-if="$slots.filters"
                    :ui="{
                        background: '!overflow-visible',
                        base: 'focus:outline-none',
                    }"
                >
                    <UButton square variant="ghost" color="gray" size="lg">
                        <FontAwesomeIcon
                            :icon="faFilters"
                            size="lg"
                            class="opacity-50"
                        />
                    </UButton>
                    <template #panel>
                        <slot name="filters" />
                    </template>
                </UPopover>
                <slot name="action" />
            </div>
        </div>
        <div class="relative flex-1 divide-y divide-gray-300">
            <div
                class="lg:absolute h-full w-full flex flex-col top-0 left-0 overflow-y-auto"
            >
                <slot />
            </div>
        </div>
        <div
            v-if="$slots.bottom"
            class="p-4 flex justify-between items-center border-t border-gray-300"
        >
            <slot name="bottom" />
        </div>
    </div>
</template>
